import { Tooltip } from "@material-ui/core";
import {
  mdiCheckDecagram,
  mdiCloseOctagon,
  mdiContentCopy,
  mdiCommentOutline,
  mdiHistory,
} from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment";
import { FunctionComponent, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  useToast,
  ToastType,
} from "../../../../../context_providers/toast/toast_ctx";
import { OrderByItemModel } from "../../../../../service/models/orders/order_model";
import { ACTION, MODULE, PO_STATUS } from "../../../../../utils/enums";
import { currencyFormat } from "../../../../../utils/currency_format";
import { useAuth } from "../../../../../context_providers/auth/authProvider";
import StatusBadge from "../../../../new_components/common/status/status_badge";

interface OrderTableWidgetProps {
  analytics?: {
    total_orders: number;
    total: number;
    subtotal: number;
    discount: number;
    addition: number;
    paid: number;
    qty: number;
    delivered_qty: number;
    installed_qty: number;
    returned_qty: number;
    net_qty: number;
  };
  orders: OrderByItemModel[];
  order_by: string;
  sort_order: string;
  selectedOrderIds?: string[];
  onSelectOrder?: (orderId: string) => void;
  onSort: (order_by: string) => void;
  onShowComment: (id: OrderByItemModel) => void;
  onShowHistory: (id: OrderByItemModel) => void;
  onOrderClick: (row: OrderByItemModel) => void;
  isOrderApprover?: boolean;
}

const OrderTableWidget: FunctionComponent<OrderTableWidgetProps> = (props) => {
  const { orders } = props;
  const { showToast } = useToast();
  const { isAuthorised } = useAuth();
  const [isWarehouseOperator, setIsWarehouseOperator] = useState(false);

  const columns: { [key: string]: string } = {
    order_id: "Order ID",
    stock_outward_status: "Order Status",
    logistic_partner: "Logistic Partner",
    logistic_tracking_id: "Logistic Tracking Id",
    created_by: "Created BY",
    order_date: "Date",
    ago: "Age",
    type: "Order type",
    "customer.firstName": "Customer",
    "customer.mobile": "Mobile",
    "customer.address.city": "City",
    "customer.address.state": "State",
    "customer.address.country": "Country",
    status: "Status",
    payment_status: "Payment Status",
    items: "Product/Service",
    "items.price": "Price",
    "items.qty": "Qty",
    "items.delivered_qty": "Delivered",
    "items.installed_qty": "Installed",
    "items.returned_qty": "Returned",
    net_qty: "Net Qty ",
    "Order_items.subtotal": "Subtotal",
    "items.discount_amt": "Discount",
    "items.addition_amt": "Extra",
    "Order_items.total": "Total",
    "Order_items.paid": "Paid",
    balance: "Balance",
    expected_pay_date: "Expected Pay Date",
    next_delivery_date: "Next Delivery Date",
    sale_by: "Sales person",
    source: "Source",
    wiring_status: "Wire status",
    site_survey: "Site survey",
    load_sancion: "Load sanction(KW)",
    subsidy_status: "Subsidy status",
    qc_status: "QC status",
    remark: "Pending collection remark",
  };

  useEffect(() => {
    const warehouse_operator_permissions = isAuthorised({
      module: MODULE.warehouse_operator,
      action: [ACTION.READ],
    });

    setIsWarehouseOperator(warehouse_operator_permissions);
  }, [isAuthorised]);

  return (
    <>
      <div
        className="hidden md:flex justify-center mt-3"
        style={{ height: "82vh" }}
      >
        <div
          id="scroll_listener"
          className=" overflow-auto h-full border border-gray-300 shadow-sm bg-white rounded-lg"
        >
          <table className=" divide-y divide-gray-200 relative">
            <thead className="  sticky  -top-1 z-10 ">
              <tr className="bg-gray-200">
                {props.isOrderApprover && (
                  <th
                    scope="col"
                    className={`px-2 py-2  text-xs font-normal   text-center   uppercase lg:sticky lg:left-0  bg-gray-200    border`}
                  >
                    Order Approval Status
                  </th>
                )}
                <th
                  scope="col"
                  className={`px-2 py-2  text-xs font-normal   text-center   uppercase lg:sticky lg:left-8  bg-gray-200    border`}
                >
                  Actions
                </th>

                {Object.keys(columns).map((column, i) => {
                  const filter_av =
                    [
                      "created_by",
                      "order_date",
                      "type",
                      "customer.firstName",
                      "customer.address.city",
                      "customer.address.state",
                      "customer.address.status",
                      "payment_status",
                      "items.price",
                      "items.qty",
                      "items.delivered_qty",
                      "items.installed_qty",
                      "items.subtotal",
                      "items.addition_amt",
                      "items.discount_amt",
                      "items.paid",
                      "items.total",
                      "expected_pay_date",
                      "next_delivery_date",
                    ].indexOf(column) !== -1;

                  return (
                    <th
                      key={i}
                      scope="col"
                      style={{
                        fontSize: "12px",
                        paddingTop: "8px",
                        paddingBottom: "8px",
                      }}
                      className={`px-3 py-1 text-center whitespace-nowrap ${
                        column === "order_date"
                          ? " lg:sticky lg:left-14"
                          : column === "customer.firstName"
                            ? " lg:sticky lg:left-32"
                            : column === "customer.address.state"
                              ? " lg:sticky lg:left-56"
                              : column === "status"
                                ? " lg:sticky lg:left-72"
                                : column === "payment_status"
                                  ? " lg:sticky lg:left-96"
                                  : ""
                      }  bg-gray-200 border`}
                    >
                      <div
                        className="flex items-center gap-2 justify-between cursor-pointer"
                        onClick={
                          filter_av ? () => props.onSort(column) : undefined
                        }
                      >
                        <div className="">
                          <p>{columns[column]}</p>
                        </div>
                        {filter_av ? (
                          <>
                            {props.order_by === column ? (
                              <Tooltip
                                title={
                                  props.sort_order === "asc"
                                    ? "Ascending"
                                    : "Descending"
                                }
                              >
                                <div className="">
                                  {props.sort_order === "asc" ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M17 13l-5 5m0 0l-5-5m5 5V6"
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M7 11l5-5m0 0l5 5m-5-5v12"
                                      />
                                    </svg>
                                  )}
                                </div>
                              </Tooltip>
                            ) : (
                              <Tooltip title="sort">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-3 w-3"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                                  />
                                </svg>
                              </Tooltip>
                            )}
                          </>
                        ) : null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>

            <tbody className="bg-white divide-y divide-gray-200 max-h-96 mx-2">
              {orders.map((order, i) => {
                const customer = order.customer || {};
                const product = Array.isArray(order.products)
                  ? order.products[0]
                  : order.products;

                const customerData = {
                  name:
                    (customer?.first_name || customer?.firstName || "") +
                    " " +
                    (customer?.last_name || customer?.lastName || ""),
                };

                const allItems = [
                  ...(order?.products || []),
                  ...(order?.services || []),
                  ...(order?.raw_materials || []),
                ];

                const subtotalSum = allItems.reduce(
                  (acc, it) => acc + (it.subtotal ?? 0),
                  0,
                );
                const totalSum = allItems.reduce(
                  (acc, it) => acc + (it.total ?? 0),
                  0,
                );
                const paidSum = allItems.reduce(
                  (acc, it) => acc + (it.paid ?? 0),
                  0,
                );
                const qtySum = allItems.reduce(
                  (acc, it) => acc + (it.qty ?? 0),
                  0,
                );
                const deliveredQtySum = allItems.reduce(
                  (acc, it) => acc + (it.delivered_qty ?? 0),
                  0,
                );
                const installedQtySum = allItems.reduce(
                  (acc, it) => acc + (it.installed_qty ?? 0),
                  0,
                );
                const returnedQtySum = allItems.reduce(
                  (acc, it) => acc + (it.returned_qty ?? 0),
                  0,
                );
                const netQtySum = deliveredQtySum - returnedQtySum;

                const balance = totalSum - paidSum;

                const currency = order.currency_to_inr > 1 ? "USD" : "INR";

                return (
                  <tr
                    style={{ fontSize: "12px" }}
                    className="sticky-row hover:bg-gray-200"
                    key={i}
                  >
                    {props.isOrderApprover && (
                      <td className=" whitespace-nowrap border sticky-field lg:sticky lg:left-0 bg-white">
                        <div className="flex items-center justify-center ">
                          {(order as any).approval_status === "Approved" ? (
                            <StatusBadge status="Approved" kind="approval" />
                          ) : (
                            <input
                              type="checkbox"
                              checked={
                                props.selectedOrderIds?.includes(
                                  order.order_id || "",
                                ) || false
                              }
                              onChange={(e) => {
                                e.stopPropagation();
                                if (props.onSelectOrder && order.order_id) {
                                  props.onSelectOrder(order.order_id);
                                }
                              }}
                              className="w-4 h-4 cursor-pointer"
                            />
                          )}
                        </div>
                      </td>
                    )}
                    <td className=" whitespace-nowrap border sticky-field lg:sticky lg:left-8">
                      <div className="flex gap-1">
                        <Tooltip title="copy order ID">
                          <svg
                            onClick={() => {
                              navigator.clipboard.writeText(order.order_id);
                              showToast({
                                type: ToastType.info,
                                text: "Copied order ID to clip board!",
                              });
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 cursor-pointer hover:text-red-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                            />
                          </svg>
                        </Tooltip>
                        <Tooltip title="comments">
                          <svg
                            onClick={() => props.onShowComment(order)}
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 hover:text-red-600 cursor-pointer"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                            />
                          </svg>
                        </Tooltip>
                        <Tooltip title="history">
                          <svg
                            onClick={() => props.onShowHistory(order)}
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4  cursor-pointer hover:text-red-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </Tooltip>
                      </div>
                    </td>

                    <td className=" px-2 py-2 whitespace-nowrap border">
                      <div className="flex">
                        <NavLink
                          target="_blank"
                          to={
                            !isWarehouseOperator
                              ? `/orders/${order.order_id}`
                              : `/orders/${order.order_id}/devices`
                          }
                        >
                          <div className="mx-1 cursor-pointer flex">
                            {order.po_status === PO_STATUS.confirmed && (
                              <span>
                                <Tooltip title={"PO " + PO_STATUS.confirmed}>
                                  <Icon
                                    className="text-green-400 h-4 w-4"
                                    path={mdiCheckDecagram}
                                  />
                                </Tooltip>
                              </span>
                            )}
                            {order.po_status === PO_STATUS.rejected && (
                              <span>
                                <Tooltip title={"PO " + PO_STATUS.rejected}>
                                  <Icon
                                    className="text-red-600 h-4 w-4"
                                    path={mdiCloseOctagon}
                                  />
                                </Tooltip>
                              </span>
                            )}
                            <span className="text-blue-400 ">
                              {order.order_id}
                            </span>
                          </div>
                        </NavLink>
                      </div>
                    </td>
                    <td
                      align="center"
                      className="whitespace-nowrap border px-2"
                    >
                      <p>{(order as any).stock_outward_status ?? "-"}</p>
                    </td>
                    <td
                      align="center"
                      className="whitespace-nowrap border px-2"
                    >
                      <p>{(order as any).logistic_partner ?? "-"}</p>
                    </td>
                    <td
                      align="center"
                      className="whitespace-nowrap border px-2"
                    >
                      <p>{(order as any).logistic_tracking_id ?? "-"}</p>
                    </td>
                    <td
                      align="center"
                      className="whitespace-nowrap border sticky-field lg:sticky lg:left-14"
                    >
                      <p>{order.created_by_name}</p>
                    </td>
                    <td
                      align="center"
                      className="whitespace-nowrap border sticky-field lg:sticky lg:left-14"
                    >
                      <p>{moment(order.created_at).format("lll")}</p>
                    </td>
                    <td align="center" className="whitespace-nowrap border">
                      <Tooltip title="Days">
                        <p>{moment().diff(moment(order.created_at), "day")}</p>
                      </Tooltip>
                    </td>
                    <td
                      align="center"
                      className="px-2 whitespace-nowrap font-medium border"
                    >
                      {order.type}
                    </td>
                    <td
                      align="left"
                      className="sticky-field lg:sticky lg:left-32 px-2 font-medium truncate h-7 border"
                      style={{ maxWidth: "150px" }}
                    >
                      <NavLink
                        target="_blank"
                        to={
                          !isWarehouseOperator
                            ? `orders/${order.order_id}`
                            : `orders/${order.order_id}/devices`
                        }
                      >
                        <div
                          title={customerData.name}
                          className="mx-1 cursor-pointer flex"
                        >
                          <span className="text-blue-400 ">
                            {customerData.name}
                          </span>
                        </div>
                      </NavLink>
                    </td>
                    <td className="p-2 whitespace-nowrap border">
                      {order.customer?.mobile}
                    </td>
                    <td className="p-2 font-medium whitespace-nowrap border">
                      {order.customer?.address?.city}
                    </td>
                    <td className="p-2 whitespace-nowrap font-medium border sticky-field lg:sticky lg:left-56">
                      {order.customer?.address?.state}
                    </td>
                    <td className="p-2 whitespace-nowrap font-medium border">
                      {order.customer?.address?.country}
                    </td>

                    <td
                      align="center"
                      className="px-3 sticky-field whitespace-nowrap lg:sticky lg:left-72 border"
                    >
                      <StatusBadge status={order.status} kind="order" />
                    </td>

                    <td
                      align="center"
                      className="sticky-field lg:sticky lg:left-96 whitespace-nowrap border"
                    >
                      <StatusBadge
                        status={order.payment_status}
                        kind="payment"
                      />
                    </td>

                    <td
                      align="left"
                      className="px-2 whitespace-nowrap truncate h-7 border"
                      style={{ maxWidth: "150px" }}
                    >
                      <div className="ml-4">{product?.item?.name ?? "--"}</div>
                    </td>
                    <td className="whitespace-nowrap text-right border px-1">
                      {currencyFormat(product?.price ?? 0, currency)}
                    </td>
                    <td className="whitespace-nowrap text-right border px-1">
                      {qtySum || "--"}
                    </td>
                    <td className="whitespace-nowrap text-right border px-1">
                      {deliveredQtySum}
                    </td>
                    <td className="whitespace-nowrap text-right border px-1">
                      {installedQtySum}
                    </td>
                    <td className="whitespace-nowrap text-right border px-1">
                      {returnedQtySum}
                    </td>
                    <td className="whitespace-nowrap text-right border px-1">
                      {netQtySum}
                    </td>
                    <td className="whitespace-nowrap border px-2 text-right">
                      {currencyFormat(subtotalSum ?? 0, currency)}
                    </td>
                    <td className="whitespace-nowrap border px-2 text-right">
                      {currencyFormat(product?.discount_amt ?? 0, currency)}
                    </td>
                    <td className="whitespace-nowrap border px-2 text-right">
                      {currencyFormat(product?.addition_amt ?? 0, currency)}
                    </td>
                    <td className="whitespace-nowrap px-1 border text-right">
                      {currencyFormat(totalSum ?? 0, currency)}
                    </td>
                    <td className="whitespace-nowrap px-1 border text-right">
                      {currencyFormat(paidSum ?? 0, currency)}
                    </td>
                    <td className="font-bold whitespace-nowrap px-1 border text-right">
                      {currencyFormat(balance ?? 0, currency)}
                    </td>

                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.expected_pay_date
                        ? moment(order.expected_pay_date).format("DD MMM YYYY")
                        : "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.next_delivery_date
                        ? moment(order.next_delivery_date).format("DD MMM YYYY")
                        : "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.sales_person_name ?? "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.source ?? "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.wiring_status ?? "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.site_survey ?? "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.load_sanction ? `${order.load_sanction} KW` : "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.subsidy_status ?? "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.qc_status ?? "--"}
                    </td>
                    <td
                      className="px-3 py-2 truncate h-7 border"
                      style={{ maxWidth: "120px" }}
                    >
                      {order.remark ?? "--"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile card view */}
      <div className="md:hidden mt-3 flex flex-col gap-3">
        {orders.map((order, i) => {
          const cust: any = order.customer || {};
          const customerName = `${
            cust?.first_name || cust?.firstName || ""
          } ${cust?.last_name || cust?.lastName || ""}`.trim();
          const isApproved = (order as any).approval_status === "Approved";
          return (
            <div
              key={i}
              className="rounded-lg border border-gray-300 shadow-sm bg-white p-3 text-sm"
            >
              {/* Header: checkbox + order id + order status */}
              <div className="flex justify-between items-start gap-2">
                <div className="flex items-center gap-2 min-w-0">
                  {props.isOrderApprover && !isApproved && (
                    <input
                      type="checkbox"
                      title="Select to approve"
                      checked={
                        props.selectedOrderIds?.includes(
                          order.order_id || "",
                        ) || false
                      }
                      onChange={() =>
                        props.onSelectOrder &&
                        order.order_id &&
                        props.onSelectOrder(order.order_id)
                      }
                      className="w-4 h-4 cursor-pointer shrink-0"
                    />
                  )}
                  <NavLink
                    target="_blank"
                    to={
                      !isWarehouseOperator
                        ? `/orders/${order.order_id}`
                        : `/orders/${order.order_id}/devices`
                    }
                    className="text-blue-500 font-semibold break-all"
                  >
                    {order.order_id}
                  </NavLink>
                </div>
                <StatusBadge status={order.status} kind="order" />
              </div>

              {/* Approval status */}
              <div className="mt-2">
                {isApproved ? (
                  <StatusBadge status="Approved" kind="approval" />
                ) : (
                  <StatusBadge status="Approval Pending" tone="warning" />
                )}
              </div>

              {/* Detail rows */}
              <div className="mt-2 flex flex-col gap-1 text-xs text-gray-600">
                <div className="flex justify-between gap-2">
                  <span className="text-gray-400">Customer</span>
                  <span className="font-medium text-gray-700 text-right break-words">
                    {customerName || "-"}
                  </span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className="text-gray-400">Created By</span>
                  <span className="text-right">
                    {order.created_by_name ?? "-"}
                  </span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className="text-gray-400">Date</span>
                  <span className="text-right">
                    {order.order_date
                      ? moment(order.order_date).format("DD MMM YYYY")
                      : "-"}
                  </span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className="text-gray-400">Logistic Partner</span>
                  <span className="text-right">
                    {(order as any).logistic_partner ?? "-"}
                  </span>
                </div>
                <div className="flex justify-between gap-2">
                  <span className="text-gray-400">Tracking Id</span>
                  <span className="text-right break-all">
                    {(order as any).logistic_tracking_id ?? "-"}
                  </span>
                </div>
              </div>

              {/* Footer: actions */}
              <div className="mt-2 flex items-center justify-end gap-3 border-t pt-2">
                <button
                  title="Copy order ID"
                  onClick={() => {
                    navigator.clipboard.writeText(order.order_id);
                    showToast({
                      type: ToastType.info,
                      text: "Copied order ID to clip board!",
                    });
                  }}
                  className="text-gray-500 hover:text-myPrimaryColor"
                >
                  <Icon path={mdiContentCopy} className="h-5 w-5" />
                </button>
                <button
                  title="Comments"
                  onClick={() => props.onShowComment(order)}
                  className="text-gray-500 hover:text-myPrimaryColor"
                >
                  <Icon path={mdiCommentOutline} className="h-5 w-5" />
                </button>
                <button
                  title="History"
                  onClick={() => props.onShowHistory(order)}
                  className="text-gray-500 hover:text-myPrimaryColor"
                >
                  <Icon path={mdiHistory} className="h-5 w-5" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default OrderTableWidget;
